import React from "react";
import style from "./instrument-card.module.css";
import { Link } from "react-router-dom";

interface InstrumentCardProps {
  img: string;
  title: string;
  caption: string;
}

function InstrumentCard({ img, title, caption }: InstrumentCardProps) {
  return (
    <Link className={style.card} to="/instruments">
      <div className={style.imageWrap}><img src={img} alt={title} /></div>
      <div className={style.copy}><div><h3>{title}</h3><p>{caption}</p></div><span>↗</span></div>
    </Link>
  );
}
export default InstrumentCard;
